<!-- =========================================================================================
    File Name: ProjectLayout.vue
    Description: Index layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div class="layout--index" :class="[layoutTypeClass, navbarClasses, footerClasses, { 'no-scroll': isAppPage }]">
    <v-nav-menu :navMenuItems="navMenuItems" title="Vuexy" parent=".layout--index" />

    <div id="content-area" :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]">
      <div id="content-overlay" />

      <!-- Navbar -->
      <template>
        <the-navbar-vertical :navbarColor="navbarColor" :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div class="router-view">
          <div class="router-content">
            <!-- pc -->
            <transition v-if="this.verticalNavMenuWidth === 'default'" :name="routerTransition">
              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div class="content-area__heading" :class="{ 'pr-4 border-0 md:border-r border-solid border-grey-light': $route.meta.breadcrumb }">
                  <h2 class="mb-1">{{ $t(routeTitle) }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb v-if="$route.meta.breadcrumb" class="ml-4 md:block hidden" :route="$route" :breadcrumb="breadcrumb" :isRTL="$vs.rtl" />
              </div>

              <div v-else-if="loadBreadCrumb.length > 0" class="router-header flex flex-wrap items-center mb-6">
                <div class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light">
                  <h2 class="mb-1">{{ $t(loadBreadCrumbTitle) }}</h2>
                </div>

                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block" :breadcrumb="loadBreadCrumb" />
                <div v-if="loadBreadCrumbNote" class="breadcrumb-note"><img src="@/assets/icons/breadcrumb-note.svg" /> {{ $t(loadBreadCrumbNote) }}</div>
              </div>
            </transition>

            <!-- mobile -->
            <transition v-else>
              <div class="content-area__heading pr-4 border-0 md:border-r border-solid border-grey-light">
                <h2 class="ml-4 mb-4">{{ $t(loadBreadCrumbTitle) }}</h2>
              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <floating-menu bottom="5%" bottom2="calc(5% + 58px)" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'">

                <!-- Ai Translate -->
                <ai-translate v-if="useAiTranslate" @close="useAiTranslate = false"/>

                <!-- Ai Voice Realtime Translate (AI 통역 PM) -->
                <ai-voice-realtime-translate v-if="useAiVoiceTranslate" @close="useAiVoiceTranslate = false"/>

                <!-- Miras Chatbot -->
                <div v-if="useCheckBot" class="ai-chatbot mb-4 border rounded-lg bg-white shadow-sm"
                     style="border:1px solid #C6C6C6; width: 330px; height: 600px; box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);"
                     :style="useCheckBotFullScreen ? {
                       width: 'calc(100% - 20px)',
                       height: 'calc(100% - 20px)',
                       position: 'fixed',
                       bottom: '0px',
                       right: '10px',
                     } : {}"
                >
                  <div class="relative h-full">
                    <!-- chatbot -->
                    <div class="h-full grid" style="grid-template-rows: auto 1fr auto">
                      <div class="flex justify-between px-4 py-4 border-bottom" >
                        <span class="font-bold text-lg" style="color:#1D1D1D">Miras Chatbot</span>

                        <div class="flex gap-2">
                          <button class="border-none bg-transparent" @click="useChatHistory = !useChatHistory">
                            <feather-icon icon="MenuIcon" class="cursor-pointer text-gray-500 hover:text-gray-700" />
                          </button>
                          <button v-if="useCheckBotFullScreen" class="border-none bg-transparent" @click="useCheckBotFullScreen = false">
                            <feather-icon icon="Minimize2Icon" class="cursor-pointer text-gray-500 hover:text-gray-700" />
                          </button>
                          <button v-else class="border-none bg-transparent" @click="useCheckBotFullScreen = true">
                            <feather-icon icon="MaximizeIcon" class="cursor-pointer text-gray-500 hover:text-gray-700" />
                          </button>
                          <button class="border-none bg-transparent" @click="useCheckBot = false">
                            <feather-icon icon="XIcon" class="cursor-pointer text-gray-500 hover:text-gray-700" />
                          </button>
                        </div>
                      </div>
                      <div ref="chatbot-body" class="p-2 overflow-y-auto">
                        <div class="flex flex-col">
                          <p v-for="(item, index) in messageHistory" :key="`message_${index}`" :class="[item.role === 'user' ? 'chat-bubble' : 'chat-response']" v-html="item.content"></p>
                          <p v-if="sending" class="chat-response typing">
                            <span></span>
                            <span></span>
                            <span></span>
                          </p>
                        </div>
                      </div>
                      <div class="flex items-center gap-2 px-2 py-2 border-top">
                        <ml-input class="flex-1" :readonly="sending" v-model="sendMessage" @keyup.enter="sendAIMessage" @paste="handlePaste"/> <!-- @paste="handlePaste" -->
                        <!-- 파일 첨부 버튼 -->
                        <!--                    <label class="cursor-pointer">-->
                        <!--                      <input type="file" accept="image/*" class="hidden" @change="handleFileUpload" />-->
                        <!--                      📎-->
                        <!--                    </label>-->
                        <vs-button @click="sendAIMessage">{{ $t('전송') }}</vs-button>
                      </div>
                    </div>

                    <!-- chatbot history -->
                    <div v-if="useChatHistory" class="absolute left-0 right-0 bottom-0 z-10 bg-white rounded-b-lg" style="top: 56px; ">
                      <div class="h-full">
                        <div class="h-full" style="display: grid; grid-template-rows: 1fr auto">
                          <div class="p-2 overflow-y-auto">
                            <p v-for="i in 5" class="flex px-2 py-4 border-bottom">
                              <span>{{ $t('네번째 대화') }}</span>
                              <span class="ml-auto" style="font-size: 13px; color:#717171;">2025-08-13</span>
                            </p>
                          </div>
                          <div class="px-2 py-2 border-top ">
                            <vs-button class="w-full" @click="initChatBotHistory">
                              <div class="flex items-center gap-2">
                                <feather-icon icon="EditIcon" />
                                {{ $t('새 채팅') }}
                              </div>
                            </vs-button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- Camera Chatbot -->
                <div v-if="useCameraTranslate" class="ai-chatbot mb-4 border rounded-lg bg-white shadow-sm"
                     style="border:1px solid #C6C6C6; width: 330px; height: 600px; box-shadow: 0 2px 15px rgba(0, 0, 0, 0.2);"
                     :style="useCameraTranslateFullScreen ? {
                       width: 'calc(100% - 20px)',
                       height: 'calc(100% - 20px)',
                       position: 'fixed',
                       bottom: '0px',
                       right: '10px',
                     } : {}"
                >
                  <div class="relative h-full">
                    <!-- chatbot -->
                    <div class="h-full grid" style="grid-template-rows: auto 1fr auto">
                      <div class="flex justify-between px-4 py-4 border-bottom" >
                        <span class="font-bold text-lg" style="color:#1D1D1D">{{ $t('이미지 번역') }}</span>

                        <div class="flex gap-2">
                          <button v-if="useCameraTranslateFullScreen" class="border-none bg-transparent" @click="useCameraTranslateFullScreen = false">
                            <feather-icon icon="Minimize2Icon" class="cursor-pointer text-gray-500 hover:text-gray-700" />
                          </button>
                          <button v-else class="border-none bg-transparent" @click="useCameraTranslateFullScreen = true">
                            <feather-icon icon="MaximizeIcon" class="cursor-pointer text-gray-500 hover:text-gray-700" />
                          </button>
                          <button class="border-none bg-transparent" @click="useCameraTranslate = false">
                            <feather-icon icon="XIcon" class="cursor-pointer text-gray-500 hover:text-gray-700" />
                          </button>
                        </div>
                      </div>
                      <div ref="chatbot-body" class="p-2 overflow-y-auto" style="position:relative;"
                           @dragover.prevent="cameraIsDragOver = true"
                           @dragleave.prevent="cameraIsDragOver = false"
                           @drop.prevent="onCameraDrop">
                        <div v-if="cameraIsDragOver" style="position:absolute;inset:0;z-index:10;background:rgba(126,114,242,0.12);border:2px dashed #7E72F2;border-radius:8px;display:flex;align-items:center;justify-content:center;pointer-events:none;">
                          <span style="color:#7E72F2;font-size:14px;font-weight:600;">이미지를 놓아주세요</span>
                        </div>
                        <div class="flex flex-col">
                          <template v-for="(item, index) in cameraMessageHistory">
                            <p :key="`cm_${index}`" v-if="item.role === 'user' || item.role === 'chatbot'" :class="[item.role === 'user' ? 'chat-bubble' : 'chat-response']" :style="item.role === 'chatbot' && item.detectedText ? 'margin-bottom:4px' : ''" v-html="item.content"></p>
                            <div :key="`cm_tts_${index}`" v-if="item.role === 'chatbot' && item.detectedText" class="flex gap-2 mb-5 ml-1">
                              <camera-tts-button :text="item.detectedText" :lang="item.detectedLang" :label="$t('원문')" />
                              <camera-tts-button :text="item.translatedText" :lang="item.translatedLang" :label="$t('번역')" />
                            </div>
                            <p :key="`cm_img_${index}`" v-if="item.role === 'img'" style="margin-bottom:12px;">
                              <img :src="item.content" alt="번역을 요청한 이미지" style="width:100%;max-width:320px;border-radius:8px;display:block;"/>
                            </p>
                          </template>
                          <p v-if="cameraSending" class="chat-response typing">
                            <span></span>
                            <span></span>
                            <span></span>
                          </p>
                        </div>
                      </div>
                      <div class="flex items-center gap-2 px-2 py-2 border-top">
                        <input type="file" accept="image/*" ref="cameraFileInput" class="hidden" @change="onCameraFileChange" />
                        <vs-button @click="$refs.cameraFileInput.click()" class="w-full">{{ $t('업로드') }}</vs-button>
                      </div>
                    </div>
                  </div>

                </div>
                <!-- Floating Menu -->
                <div v-if="floatingMenuOpen" class="flex flex-col items-end gap-2">
                  <div class="floating-menu-item cursor-pointer" @click="onClickFloatingMenu('realtime-translate')">
                    <span>{{ $t('AI 통역') }}</span>
                    <img :src="require('@/assets/icons/translation.png')" alt="번역아이콘" width="24" height="24"/>
                  </div>
                  <div v-if="canUseVoiceTranslatePm" class="floating-menu-item cursor-pointer" @click="onClickFloatingMenu('realtime-translate-pm')">
                    <span>{{ $t('AI 통역 PM') }}</span>
                    <feather-icon icon="MicIcon"/>
                  </div>
                  <div v-if="canUseVoiceTranslatePt" class="floating-menu-item cursor-pointer" @click="onClickFloatingMenu('realtime-translate-pt')">
                    <span>{{ $t('AI 통역 PT') }}</span>
                    <feather-icon icon="RadioIcon"/>
                  </div>
                  <div class="floating-menu-item cursor-pointer" @click="onClickFloatingMenu('chatbot')">
                    <span>Miras Chatbot</span>
                    <feather-icon icon="MessageCircleIcon"/>
                  </div>
                  <vx-tooltip
                    v-if="canUsePageTranslate && isKoreanLocale"
                    :title="$t('페이지 번역')"
                    :text="$t('한국어가 아닌 다른 언어를 선택해주세요')"
                    position="left"
                  >
                    <div
                      class="floating-menu-item floating-menu-item-disabled"
                      @click="onClickFloatingMenu('page-translate')"
                    >
                      <span>{{ $t('페이지 번역') }}</span>
                      <span style="width: 24px; height: 24px;">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_3698_18634_disabled)">
                            <path d="M0.292893 0.292893C0.683418 -0.0976311 1.31643 -0.0976311 1.70696 0.292893L23.707 22.2929L23.7753 22.3691C24.0957 22.7618 24.0731 23.3408 23.707 23.707C23.3408 24.0731 22.7618 24.0957 22.3691 23.7753L22.2929 23.707L0.292893 1.70696C-0.0976311 1.31643 -0.0976311 0.683418 0.292893 0.292893Z" fill="white"/>
                            <path d="M6 6H3.75C3.34074 6 3.00015 6.33482 3 6.75879V20.832C3.00023 21.2559 3.34079 21.5908 3.75 21.5908H14.25C14.6592 21.5908 14.9998 21.2559 15 20.832V15L17 17V20.832C16.9998 22.3507 15.7735 23.5908 14.25 23.5908H3.75C2.22649 23.5908 1.00023 22.3507 1 20.832V6.75879C1.00015 5.24 2.22644 4 3.75 4H4L6 6ZM12.5 17.1934C13.0523 17.1934 13.5 17.6411 13.5 18.1934C13.5 18.7456 13.0523 19.1934 12.5 19.1934H5.5C4.94772 19.1934 4.5 18.7456 4.5 18.1934C4.5 17.6411 4.94772 17.1934 5.5 17.1934H12.5ZM12.5 13.6748C13.0523 13.6748 13.5 14.1225 13.5 14.6748C13.5 15.2271 13.0523 15.6748 12.5 15.6748H5.5C4.94772 15.6748 4.5 15.2271 4.5 14.6748C4.5 14.1225 4.94772 13.6748 5.5 13.6748H12.5ZM7.25 10.1562C7.80228 10.1562 8.25 10.604 8.25 11.1562C8.25 11.7085 7.80228 12.1562 7.25 12.1562H5.5C4.94772 12.1562 4.5 11.7085 4.5 11.1562C4.5 10.604 4.94772 10.1562 5.5 10.1562H7.25Z" fill="white"/>
                            <path d="M17.6035 2.32422H23.4639V4.06738H21.3223C20.5337 6.23389 19.4712 8.02686 18.1182 9.49609C19.6372 10.6582 21.4966 11.5215 23.7461 12.0361C23.3145 12.4346 22.7334 13.2979 22.4346 13.8125C20.0688 13.1982 18.1597 12.2271 16.6074 10.9072C15.6719 11.6625 14.6266 12.3012 13.4736 12.8428L11.9014 11.3994C13.1625 10.9062 14.2748 10.3018 15.2461 9.5625C13.918 8.05176 12.9053 6.21729 12.125 4.06738H10V2.32422H15.7607V0H17.6035V2.32422ZM14.1006 4.06738C14.7231 5.64453 15.5864 7.04736 16.7236 8.23438C17.7695 7.08887 18.6079 5.71094 19.2305 4.06738H14.1006Z" fill="white"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_3698_18634_disabled">
                          <rect width="24" height="24" fill="white"/>
                          </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </div>
                  </vx-tooltip>
                  <div
                    v-else-if="canUsePageTranslate"
                    class="floating-menu-item cursor-pointer"
                    @click="onClickFloatingMenu('page-translate')"
                  >
                    <span>{{ $t('페이지 번역') }}</span>
                    <span style="width: 24px; height: 24px;">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3698_18634)">
                          <path d="M0.292893 0.292893C0.683418 -0.0976311 1.31643 -0.0976311 1.70696 0.292893L23.707 22.2929L23.7753 22.3691C24.0957 22.7618 24.0731 23.3408 23.707 23.707C23.3408 24.0731 22.7618 24.0957 22.3691 23.7753L22.2929 23.707L0.292893 1.70696C-0.0976311 1.31643 -0.0976311 0.683418 0.292893 0.292893Z" fill="white"/>
                          <path d="M6 6H3.75C3.34074 6 3.00015 6.33482 3 6.75879V20.832C3.00023 21.2559 3.34079 21.5908 3.75 21.5908H14.25C14.6592 21.5908 14.9998 21.2559 15 20.832V15L17 17V20.832C16.9998 22.3507 15.7735 23.5908 14.25 23.5908H3.75C2.22649 23.5908 1.00023 22.3507 1 20.832V6.75879C1.00015 5.24 2.22644 4 3.75 4H4L6 6ZM12.5 17.1934C13.0523 17.1934 13.5 17.6411 13.5 18.1934C13.5 18.7456 13.0523 19.1934 12.5 19.1934H5.5C4.94772 19.1934 4.5 18.7456 4.5 18.1934C4.5 17.6411 4.94772 17.1934 5.5 17.1934H12.5ZM12.5 13.6748C13.0523 13.6748 13.5 14.1225 13.5 14.6748C13.5 15.2271 13.0523 15.6748 12.5 15.6748H5.5C4.94772 15.6748 4.5 15.2271 4.5 14.6748C4.5 14.1225 4.94772 13.6748 5.5 13.6748H12.5ZM7.25 10.1562C7.80228 10.1562 8.25 10.604 8.25 11.1562C8.25 11.7085 7.80228 12.1562 7.25 12.1562H5.5C4.94772 12.1562 4.5 11.7085 4.5 11.1562C4.5 10.604 4.94772 10.1562 5.5 10.1562H7.25Z" fill="white"/>
                          <path d="M17.6035 2.32422H23.4639V4.06738H21.3223C20.5337 6.23389 19.4712 8.02686 18.1182 9.49609C19.6372 10.6582 21.4966 11.5215 23.7461 12.0361C23.3145 12.4346 22.7334 13.2979 22.4346 13.8125C20.0688 13.1982 18.1597 12.2271 16.6074 10.9072C15.6719 11.6625 14.6266 12.3012 13.4736 12.8428L11.9014 11.3994C13.1625 10.9062 14.2748 10.3018 15.2461 9.5625C13.918 8.05176 12.9053 6.21729 12.125 4.06738H10V2.32422H15.7607V0H17.6035V2.32422ZM14.1006 4.06738C14.7231 5.64453 15.5864 7.04736 16.7236 8.23438C17.7695 7.08887 18.6079 5.71094 19.2305 4.06738H14.1006Z" fill="white"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_3698_18634">
                        <rect width="24" height="24" fill="white"/>
                        </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </div>
                  <div class="floating-menu-item cursor-pointer" @click="onClickFloatingMenu('camera-translate')">
                    <span>{{ $t('이미지 번역') }}</span>
                    <span style="width: 24px; height: 24px;">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_3698_18638)">
                          <path d="M0.292893 0.292893C0.683418 -0.0976311 1.31643 -0.0976311 1.70696 0.292893L23.707 22.2929L23.7753 22.3691C24.0957 22.7618 24.0731 23.3408 23.707 23.707C23.3408 24.0731 22.7618 24.0957 22.3691 23.7753L22.2929 23.707L0.292893 1.70696C-0.0976311 1.31643 -0.0976311 0.683418 0.292893 0.292893Z" fill="white"/>
                          <path d="M6 5C6.55228 5 7 5.44772 7 6C7 6.55228 6.55228 7 6 7H3C2.73478 7 2.4805 7.10543 2.29297 7.29297C2.10543 7.4805 2 7.73478 2 8V19C2 19.2652 2.10543 19.5195 2.29297 19.707C2.48051 19.8946 2.73478 20 3 20H21C21.5523 20 22 20.4477 22 21C22 21.5523 21.5523 22 21 22H3C2.20435 22 1.44151 21.6837 0.878906 21.1211C0.316297 20.5585 0 19.7956 0 19V8C0 7.20435 0.316297 6.44152 0.878906 5.87891C1.44152 5.3163 2.20435 5 3 5H6ZM9.15527 8.89453C9.611 8.58275 10.233 8.69965 10.5449 9.15527C10.8567 9.61091 10.7406 10.2329 10.2852 10.5449C9.92137 10.7938 9.61606 11.1201 9.39258 11.5C9.16919 11.8798 9.03302 12.3044 8.99219 12.7432C8.9514 13.1821 9.00758 13.6254 9.15723 14.04C9.30688 14.4545 9.54584 14.831 9.85742 15.1426C10.169 15.4542 10.5455 15.6931 10.96 15.8428C11.3746 15.9924 11.8179 16.0486 12.2568 16.0078C12.6956 15.967 13.1202 15.8308 13.5 15.6074C13.8799 15.3839 14.2062 15.0786 14.4551 14.7148C14.7671 14.2594 15.3891 14.1433 15.8447 14.4551C16.3003 14.767 16.4172 15.389 16.1055 15.8447C15.6906 16.451 15.1469 16.9586 14.5137 17.3311C13.8805 17.7035 13.1729 17.932 12.4414 18C11.7099 18.068 10.9723 17.974 10.2812 17.7246C9.59022 17.4752 8.96284 17.0761 8.44336 16.5566C7.92388 16.0372 7.5248 15.4098 7.27539 14.7188C7.02599 14.0277 6.93204 13.2901 7 12.5586C7.06797 11.8271 7.29653 11.1195 7.66895 10.4863C8.04141 9.85308 8.54896 9.30941 9.15527 8.89453Z" fill="white"/>
                          <path d="M17.6035 2.32422H23.4639V4.06738H21.3223C20.5337 6.23389 19.4712 8.02686 18.1182 9.49609C19.6372 10.6582 21.4966 11.5215 23.7461 12.0361C23.3145 12.4346 22.7334 13.2979 22.4346 13.8125C20.0688 13.1982 18.1597 12.2271 16.6074 10.9072C15.6719 11.6625 14.6266 12.3012 13.4736 12.8428L11.9014 11.3994C13.1625 10.9062 14.2748 10.3018 15.2461 9.5625C13.918 8.05176 12.9053 6.21729 12.125 4.06738H10V2.32422H15.7607V0H17.6035V2.32422ZM14.1006 4.06738C14.7231 5.64453 15.5864 7.04736 16.7236 8.23438C17.7695 7.08887 18.6079 5.71094 19.2305 4.06738H14.1006Z" fill="white"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_3698_18638">
                          <rect width="24" height="24" fill="white"/>
                        </clipPath>
                        </defs>
                      </svg>
                    </span>
                  </div>
                  <div class="floating-menu-item cursor-pointer" style="background-color: #F55862;" @click="onClickFloatingMenu('alert')">
                    <span>{{ $t('경보(긴급공지)') }}</span>
                    <feather-icon icon="AlertOctagonIcon"/>
                  </div>
                </div>
                <div class="mt-2 flex flex-col items-end gap-2">
                  <div class="floating-menu-item cursor-pointer" style="width: 48px; height: 48px; padding: 0; justify-content: center;" @click="onClickFloatingMenuToggle">
                    <feather-icon v-if="floatingMenuOpen" icon="XIcon" />
                    <feather-icon v-else icon="MenuIcon"/>
                  </div>
                </div>

              </floating-menu>

              <transition :name="routerTransition" mode="out-in">
                <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
              </transition>
            </div>
          </div>
        </div>
      </div>
      <the-footer />
    </div>

    <navigation-dialog v-if="openAiCamera" title="카메라 번역" use-close @close="openAiCamera = false">
      <ai-camera ref="stackCamera" title="카메라 번역" @back="openAiCamera = false" @success="qrScanSuccess"/>
    </navigation-dialog>

    <navigation-dialog v-if="openImageTranslate" :title="$t('이미지 번역')" use-close @close="openImageTranslate = false">
      <image-translate @success="qrScanSuccess"/>
    </navigation-dialog>
  </div>
</template>

<script>
import BackToTop from 'vue-backtotop'
import navMenuItem1 from '@/layouts/sidemenu/project_1'
import navMenuItem3 from '@/layouts/sidemenu/project_3'
import navMenuItem4 from '@/layouts/sidemenu/project_4'
import navMenuItem5 from '@/layouts/sidemenu/project_5'
import navMenuItem6 from '@/layouts/sidemenu/project_6'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter from '@/layouts/components/TheFooter.vue'
import themeConfig from '../../themeConfig.js'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import FloatingMenu from "@/layouts/FloatingMenu.vue";
import HttpRequest from "@/util/HttpRequest";
import { marked } from 'marked';
import QrScanCamera from "@/layouts/components/navbar/components/qr-scan-manager/QrScanCamera.vue";
import NavigationDialog from "@/components/dialog/NavigationDialog.vue";
import AiCamera from "@/layouts/components/AiCamera.vue";
import ImageTranslate from "@/layouts/components/ImageTranslate.vue";
import CameraTtsButton from "@/layouts/components/CameraTtsButton.vue";
import * as UiUtil from "@/util/UiUtil";
import AiTranslate from "@/layouts/components/ai-translate/AiTranslate.vue";
import AiVoiceRealtimeTranslate from "@/layouts/components/ai-translate/AiVoiceRealtimeTranslate.vue";
import VxTooltip from "@/layouts/components/vx-tooltip/VxTooltip.vue";

export default {
  components: {
    VxTooltip,
    AiTranslate,
    AiVoiceRealtimeTranslate,
    AiCamera,
    ImageTranslate,
    CameraTtsButton,
    NavigationDialog,
    QrScanCamera,
    FloatingMenu,
    BackToTop,
    TheFooter,
    TheNavbarVertical,
    VNavMenu,
  },
  data() {
    return {
      footerType: themeConfig.footerType || "static",
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || "#fff",
      navbarType: themeConfig.navbarType || "floating",
      navMenuItem: {
        '1': navMenuItem1,
        '3': navMenuItem3,
        '4': navMenuItem4,
        '5': navMenuItem5,
        '6': navMenuItem6,
      },
      routerTransition: themeConfig.routerTransition || "none",
      routeTitle: this.$route.meta.pageTitle,
      useAiTranslate: false,
      useAiVoiceTranslate: false,
      useCheckBot: false,
      useCheckBotFullScreen: false,
      useChatHistory: false,
      sendMessage: "",
      sending: false,
      messageHistory: [],

      useCameraTranslate: false,
      useCameraTranslateFullScreen: false,
      cameraSending: false,
      cameraMessageHistory: [],
      cameraIsDragOver: false,

      floatingMenuOpen: false,
      openAiCamera: false,
      openImageTranslate: false,
      isMobile: false,

    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor === "#fff" && val ? "#10163a" : "#fff";
      this.updateNavbarColor(color);
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val);
    },
  },
  computed: {
    canUseVoiceTranslatePm() {
      const username = localStorage.getItem("login_username");
      return username === 'lv00000001!';
    },
    canUseVoiceTranslatePt() {
      const username = localStorage.getItem("login_username");
      // lv00000001! 계정(테스트/관리자)은 모바일에서도 표시.
      if (username === 'lv00000001!') return true;
      // 그 외 사용자는 PT 의 빔프로젝트 풀스크린 시나리오 특성상 모바일 숨김.
      if (this.isMobile) return false;
      return false;
    },
    keyLocalStorageBoardIds() {
      const username = localStorage.getItem("login_username");
      const projectId = this.$route.params.proj_id;
      return `${username}_${projectId}_boardIds`;
    },
    menuList() {
      return this.$store.state.menu.list;
    },
    menuListByResolutions() {
      const result = [];

      const filterByResolution = (menuList) => {
        const filteredList = [];
        for (const item of menuList) {
          if ((this.isXs && this.isTrue(item.showXs)) || (this.isSm && this.isTrue(item.showSm)) ||
            (this.isMd && this.isTrue(item.showMd)) || (this.isLg && this.isTrue(item.showLg)) ||
            (this.isXl && this.isTrue(item.showXl))) {
            const newItem = { ...item }; // item 복사
            if (item.children && item.children.length > 0) {
              newItem.children = filterByResolution(item.children); // 재귀적으로 children 처리
            }
            filteredList.push(newItem);
          }
        }
        return filteredList;
      };

      if (this.menuList) {
        result.push(...filterByResolution(this.menuList));
      }

      return result;
    },

    /** 현재 화면의 너비가 xs 사이즈인지 체크 (Quasar 기준) */
    isXs() {
      return this.windowWidth < 600;
    },
    /** 현재 화면의 너비가 sm 사이즈인지 체크 (Quasar 기준) */
    isSm() {
      return this.windowWidth >= 600 && this.windowWidth < 1024;
    },
    /** 현재 화면의 너비가 md 사이즈인지 체크 (Quasar 기준) */
    isMd() {
      return this.windowWidth >= 1024 && this.windowWidth < 1440;
    },
    /** 현재 화면의 너비가 lg 사이즈인지 체크 (Quasar 기준) */
    isLg() {
      return this.windowWidth >= 1440 && this.windowWidth < 1920;
    },
    /** 현재 화면의 너비가 xl 사이즈인지 체크 (Quasar 기준) */
    isXl() {
      return this.windowWidth >= 1920;
    },
    navMenuItems() {
      if (!this.menuListByResolutions) return

      const memberInfo = this.$store.state.member.memberInfo;

      const projectId = this.$route.params.proj_id;
      /** 메뉴 권한이 있는 메뉴 */
      const boardIds = this.boardIds ? this.boardIds : [];
      /** 모든 메뉴 */
      const urlObject = JSON.parse(JSON.stringify(this.menuListByResolutions));

      // 만약 참여하고 있는 프로젝트 개수가 1개라면, "분야 바로가기" 항목은 제거한다
      if (memberInfo && memberInfo.projects && (memberInfo.projects.length || 0) === 1) {
        // url 아이템 중에서 name 값에 "바로가기" 텍스트가 있는 아이템을 제거한다
        for (let i = 0; i < urlObject.length; i++) {
          if (urlObject[i].name.includes("바로가기")) {
            urlObject.splice(i, 1);
            i--;
          }
        }
      }

      // 통합 메뉴 이동 여부
      const useBackMenu = true;
      if (useBackMenu) {
      } else {
        urlObject.splice(0, 1);
      }

      // 메뉴권한 처리
      if (urlObject) {
        for (let i = 0; i < urlObject.length; i++) {
          const useMenu = this.__useMenu__(urlObject[i], boardIds).enabled;
          if (!useMenu) {
            urlObject.splice(i, 1);
            i--;
          }
        }
      }

      const path = this.$route.path;
      const pathArray = path.split("/");
      const rootPath = pathArray.length > 2 ? `${pathArray[0]}/${pathArray[1]}/${pathArray[2]}` : "";
      this.changeRootUrl(urlObject, rootPath);
      return urlObject;
    },
    breadcrumb() {
      const breadcrumb = JSON.parse(JSON.stringify(this.$route.meta.breadcrumb));
      return breadcrumb;
    },
    loadBreadCrumb() {
      if (this.$store.state.menu.pagePath) {
        return this.$store.state.menu.pagePath;
      }
      return [];
    },
    loadBreadCrumbTitle() {
      if (this.loadBreadCrumb.length > 0) {
        return this.loadBreadCrumb[this.loadBreadCrumb.length - 1].title;
      }
      return "";
    },
    /**
     * 현재 페이지의 breadcrumb note 를 가져온다.
     * @returns {*|null}
     */
    loadBreadCrumbNote() {
      if (this.$store.state.menu.pagePath) {
        const lastItem = this.$store.state.menu.pagePath[this.$store.state.menu.pagePath.length - 1];
        if (lastItem && lastItem.note) {
          return lastItem.note;
        }
      }
      return null
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      if (this.mainLayoutType === "vertical") {
        if (this.verticalNavMenuWidth === "default") return "content-area-reduced";
        else if (this.verticalNavMenuWidth === "reduced") return "content-area-lg";
        else return "content-area-full";
      } else return "content-area-full";
    },
    footerClasses() {
      return {
        "footer-hidden": this.footerType === "hidden",
        "footer-sticky": this.footerType === "sticky",
        "footer-static": this.footerType === "static",
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme === "dark";
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        "navbar-hidden": this.navbarType === "hidden",
        "navbar-sticky": this.navbarType === "sticky",
        "navbar-static": this.navbarType === "static",
        "navbar-floating": this.navbarType === "floating",
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    canUsePageTranslate() {
      // postId가 없으면 신규 작성 중이므로 번역 버튼 숨김
      if (!this.postId) {
        return false;
      }
      return this.$store.state.menu.canUsePageTranslate;
    },
    isKoreanLocale() {
      return this.$i18n.locale === 'ko-KR' || this.$i18n.locale.startsWith('ko');
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
    projectId() {
      return this.$route.params.proj_id;
    },
    boardIds() {
      const boardIds = JSON.parse(localStorage.getItem(this.keyLocalStorageBoardIds));

      if (!boardIds) {
        const boardIds = [];
        //await this.$store.dispatch("member/LOAD_MEMBER_DETAIL", { project_id: this.projectId });
        if (this.$store.state.member.memberInfo) {

          const boards = this.$store.state.member.memberInfo.boards;
          if (boards && boards.length > 0) {
            for (const board of boards) {
              if (`${board.pivot.project_id}` === `${this.projectId}` && board.pivot.v === 1) {
                boardIds.push(board.id);
              }
            }
            const newBoardIds = [...new Set(boardIds)];
            this.$store.commit("menu/SET_AVAILABLE_BOARD_IDS", newBoardIds);
            localStorage.setItem(this.keyLocalStorageBoardIds, JSON.stringify(newBoardIds));
            return newBoardIds;
          } else {
            this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
          }

          this.$store.commit("menu/SET_AVAILABLE_BOARD_IDS", boardIds);
          return boardIds;
        }

        this.$store.commit("menu/SET_AVAILABLE_BOARD_IDS", boardIds);
        return boardIds;
      }

      this.$store.commit("menu/SET_AVAILABLE_BOARD_IDS", boardIds);
      return boardIds;
    },
    getLevel() {
      const projects = this.$store.state.member.memberInfo.projects;
      if (projects) {
        for (const proj of projects) {
          if (proj.id == this.projectId && proj.company.length > 0) {
            const path = proj.company[0].pivot.company_path;
            const lv = path.split("/").length - 1;
            return lv;
          }
        }
      }
    },
  },
  methods: {
    isTrue(value) {
      return value === "true" || value === true;
    },
    async loadAlertList() {
      await this.$store.dispatch("approval/LOAD_NOTIFICATION_UNREAD_LIST", {
        page_unread: 1,
        per_page_unread: 5,
        days_before_unread: 30,
      });
    },
    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val === "#fff") this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    setNavMenuVisibility(layoutType) {
      if ((layoutType === "horizontal" && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", false);
        this.$store.dispatch("updateVerticalNavMenuWidth", "no-nav-menu");
      } else {
        this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
      }
    },
    changeRootUrl(list, rootUrl) {
      if (list && list.length > 0) {
        for (const item of list) {
          if (item.url) {
            if (typeof item.url === "string" && item.url.indexOf(rootUrl) < 0) {
              item.url = `${rootUrl}${item.url}`;
            }
          }

          if (item.submenu && item.submenu.length > 0) {
            this.changeRootUrl(item.submenu, rootUrl);
          }
        }
      }
    },

    onClickFloatingMenu(key) {
      if (key === 'chatbot') {
        this.useCheckBot = !this.useCheckBot;
      } else if (key === 'page-translate') {
        // 한국어일 경우 동작하지 않음
        if (this.isKoreanLocale) {
          // 모바일에서 알림 표시
          this.$vs.notify({
            title: this.$t('페이지 번역'),
            text: this.$t('한국어가 아닌 다른 언어를 선택해주세요'),
            color: 'warning',
            position: 'top-center',
            time: 3000
          });
          return;
        }
        this.$store.commit("menu/TOGGLE_PAGE_TRANSLATE");
      } else if (key === 'camera-translate') {
        if (this.cameraMessageHistory.length === 0) {
          if (this.isMobile) {
            this.openAiCamera = true;
            this.$nextTick(() => {
              this.$refs.stackCamera.openDialog();
            });
          } else {
            this.openImageTranslate = true;
          }
        } else {
          this.useCameraTranslate = true;
        }
      } else if (key === 'alert') {
        this.$router.push(`/project/${this.projectId}/tab/1091`);
      } else if (key === 'realtime-translate') {
        this.useAiTranslate = !this.useAiTranslate;
      } else if (key === 'realtime-translate-pm') {
        this.useAiVoiceTranslate = !this.useAiVoiceTranslate;
      } else if (key === 'realtime-translate-pt') {
        // PT는 풀스크린 페이지로 라우팅 (빔프로젝트 시나리오)
        this.$router.push('/project/' + this.projectId + '/ai-voice-pt').catch(() => {})
      }
    },
    onClickFloatingMenuToggle() {
      this.floatingMenuOpen = !this.floatingMenuOpen;
      localStorage.setItem('FloatingMenu', this.floatingMenuOpen);
    },

    async onClickCamera () {
      this.openAiCamera = true;
      this.$nextTick(() => {
        this.$refs.stackCamera.openDialog();
      });
    },

    onCameraFileChange(event) {
      const file = event.target.files[0];
      event.target.value = '';
      if (file && file.type.indexOf('image') !== -1) {
        this.qrScanSuccess(file);
      }
    },

    onCameraDrop(event) {
      this.cameraIsDragOver = false;
      const items = event.dataTransfer ? event.dataTransfer.items : [];
      if (!items) return;
      for (let i = 0; i < items.length; i++) {
        if (items[i].kind === 'file' && items[i].type.indexOf('image') !== -1) {
          const file = items[i].getAsFile();
          if (file) {
            this.qrScanSuccess(file);
            break;
          }
        }
      }
    },

    detectLangFromText(text) {
      if (!text) return null;
      const sample = text.substring(0, 200);
      const counts = { cyrillic: 0, chinese: 0, japanese: 0, arabic: 0, thai: 0, devanagari: 0, bengali: 0 };
      for (let i = 0; i < sample.length; i++) {
        const code = sample.charCodeAt(i);
        if (code >= 0x0400 && code <= 0x04FF) counts.cyrillic++;
        else if (code >= 0x4E00 && code <= 0x9FFF) counts.chinese++;
        else if ((code >= 0x3040 && code <= 0x30FF) || (code >= 0xFF65 && code <= 0xFF9F)) counts.japanese++;
        else if (code >= 0x0600 && code <= 0x06FF) counts.arabic++;
        else if (code >= 0x0E00 && code <= 0x0E7F) counts.thai++;
        else if (code >= 0x0900 && code <= 0x097F) counts.devanagari++;
        else if (code >= 0x0980 && code <= 0x09FF) counts.bengali++;
      }
      const langMap = { cyrillic: 'ru', chinese: 'zh', japanese: 'ja', arabic: 'ar', thai: 'th', devanagari: 'hi', bengali: 'bn' };
      let maxKey = null;
      let maxVal = 0;
      const keys = Object.keys(counts);
      for (let i = 0; i < keys.length; i++) {
        if (counts[keys[i]] > maxVal) {
          maxVal = counts[keys[i]];
          maxKey = keys[i];
        }
      }
      if (maxVal === 0) return null;
      return langMap[maxKey] || null;
    },

    formatImageTranslateResult(data) {
      const detected = data.detected_text || '';
      const translated = data.translated_text || '';
      const explanation = data.detailed_explanation || '';
      const priority = data.safety_priority || '';
      const actions = Array.isArray(data.recommended_actions) ? data.recommended_actions : [];

      const priorityInfo = {
        low: { label: '낮음', bg: '#D1FAE5', color: '#065F46' },
        medium: { label: '중간', bg: '#FEF3C7', color: '#92400E' },
        high: { label: '높음', bg: '#FEE2E2', color: '#991B1B' }
      };
      const p = priorityInfo[priority] || { label: priority, bg: '#F3F4F6', color: '#374151' };

      let html = '<div style="font-size:14px;line-height:1.6;">';

      if (translated) {
        html += `${'<div style="margin-bottom:10px;">'
          + '<div style="font-size:12px;color:#6B7280;font-weight:600;margin-bottom:3px;">번역</div>'
          + '<div style="color:#1D1D1D;">'}${  translated  }</div>`
          + `</div>`;
      }

      if (detected) {
        html += `${'<hr style="border:none;border-top:1px solid #E5E7EB;margin:8px 0;">'
          + '<div style="margin-bottom:10px;">'
          + '<div style="font-size:12px;color:#6B7280;font-weight:600;margin-bottom:3px;">원문</div>'
          + '<div style="color:#4B5563;">'}${  detected  }</div>`
          + `</div>`;
      }

      if (explanation) {
        html += `${'<hr style="border:none;border-top:1px solid #E5E7EB;margin:8px 0;">'
          + '<div style="margin-bottom:10px;">'
          + '<div style="font-size:12px;color:#6B7280;font-weight:600;margin-bottom:3px;">상세 설명</div>'
          + '<div style="color:#4B5563;">'}${  explanation  }</div>`
          + `</div>`;
      }

      if (priority) {
        html += `${'<hr style="border:none;border-top:1px solid #E5E7EB;margin:8px 0;">'
          + '<div style="margin-bottom:10px;">'
          + '<div style="font-size:12px;color:#6B7280;font-weight:600;margin-bottom:3px;">안전 우선순위</div>'
          + '<span style="background:'}${  p.bg  };color:${  p.color  };padding:2px 8px;border-radius:4px;font-size:12px;font-weight:600;">${  p.label  }</span>`
          + `</div>`;
      }

      if (actions.length > 0) {
        html += '<hr style="border:none;border-top:1px solid #E5E7EB;margin:8px 0;">'
          + '<div>'
          + '<div style="font-size:12px;color:#6B7280;font-weight:600;margin-bottom:3px;">권장 행동</div>'
          + '<ul style="margin:0;padding-left:16px;color:#4B5563;">';
        for (let i = 0; i < actions.length; i++) {
          html += `<li style="margin-bottom:2px;">${  actions[i]  }</li>`;
        }
        html += '</ul></div>';
      }

      html += '</div>';
      return html;
    },

    async qrScanSuccess(file) {
      const url = URL.createObjectURL(file);
      this.cameraMessageHistory.push({
        role: 'img',
        content: url
      })

      if (this.$refs.stackCamera) {
        this.$refs.stackCamera.closeDialog();
      }
      this.openAiCamera = false;
      this.openImageTranslate = false;
      this.useCameraTranslate = true;
      this.cameraSending = true;
      try {
        const formData = new FormData();
        formData.append('image', file, 'camera-translate.png');
        formData.append('lang', this.$i18n.locale.split("_")[0]);
        //formData.append('content', '')
        await HttpRequest.post('/api/v1/miras/translate-image', formData)
          .then(response => {
            this.cameraMessageHistory.push({
              role: 'chatbot',
              content: this.formatImageTranslateResult(response.data),
              detectedText: response.data.detected_text || '',
              translatedText: response.data.translated_text || '',
              translatedLang: this.$i18n.locale.split("_")[0],
              detectedLang: this.detectLangFromText(response.data.detected_text || ''),
            })
          })
          .catch(err => {
            console.error('uploadImage', err);
          });
        this.cameraSending = false;

      } catch (err) {
        console.log("uploadImage try-catch", err)
      }
    },

    async sendAIMessage () {
      if (this.sendMessage) {
        this.sending = true;
        const toLang = this.$i18n.locale
        const option = {
          message: this.sendMessage,
          lang: toLang,
        }
        if (this.messageHistory[this.messageHistory.length - 1]) {
          option.session_id = this.messageHistory[this.messageHistory.length - 1].session_id;
        }
        this.messageHistory.push({
          session_id: this.messageHistory.length > 0 ? this.messageHistory[this.messageHistory.length - 1].session_id : 0,
          role: 'user',
          content: this.sendMessage
        })
        this.sendMessage = '';

        this.$nextTick(() => {
          const el = this.$refs['chatbot-body'];
          if (el) {
            el.scrollTop = el.scrollHeight;
          }
        });
        try {
          await HttpRequest.post('/api/v1/miras/chatbot', option)
            .then(response => {
              if (this.messageHistory.length > 0) {
                this.messageHistory.push({
                  session_id: response.data.session_id,
                  role: 'chatbot',
                  content: marked(response.data.response)
                })
              }
            }).catch(err => {
              console.error("sendAIMessage", err)
            })
        } catch (err) {
          console.log("sendAIMessage try-catch", err)
        }
        this.sending = false;
      }
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadImage(file);
      }
    },
    handlePaste(event) {
      const items = (event.clipboardData || event.originalEvent.clipboardData).items;
      for (const item of items) {
        if (item.type.indexOf("image") !== -1) {
          const file = item.getAsFile();
          this.uploadImage(file);
        }
      }
    },
    initChatBotHistory() {
      this.useChatHistory = false
      this.useCheckBot = true;
      this.useCheckBotFullScreen = false;
      this.sendMessage = "";
      this.sending = false;
      this.messageHistory = [];
    },
    async uploadImage(file) {
      console.log("업로드할 이미지:", file);
      // 👉 여기서 FormData 만들어서 API 전송

      try {
        UiUtil.loading(true);
        const formData = new FormData();
        formData.append('image', file);
        formData.append('lang', this.$i18n.locale.split("_")[0]);
        //formData.append('content', '')
        await HttpRequest.post('/api/v1/miras/translate-image', formData)
          .then(response => {
            console.log("response", response)
          })
          .catch(err => {
            console.error('uploadImage', err);
          });

      } catch (err) {
        console.log("uploadImage try-catch", err)
      }
      UiUtil.loading(false);

    },

    __useMenu__(urlObject, boardIds) {
      let enabled = false
      let tab = false

      if (urlObject) {

        // submenu 가 있는 경우
        if (urlObject.submenu) {
          let allDisabledSubMenu = true;
          let tabCount = 0;
          for (let i = 0; i < urlObject.submenu.length; i++) {
            const useMenu = this.__useMenu__(urlObject.submenu[i], boardIds)
            // 권한이 있는 탭의 개수 체크
            if (useMenu.enabled && useMenu.tab) {
              tabCount++;
            }
            const enabledSubMenu = useMenu.enabled;
            if (!enabledSubMenu) {
              urlObject.submenu.splice(i, 1);
              i--;
            } else {
              allDisabledSubMenu = false;
            }
          }

          // 하나라도 활성화된 메뉴가 있거나, 하위 메뉴가 권한이 있는 탭 메뉴를 가지는 경우 상위 메뉴 활성화
          enabled = (tabCount > 0) || !allDisabledSubMenu;
        } else if (urlObject.visible === 'hide') {
          enabled = false;
        }

        // groupName 이 있는 경우
        else if (urlObject.groupName && urlObject.groupName.length > 0) {
          for (const boardId of urlObject.groupName) {
            try {
              const bid = this.__getBidWithStringBoardId(boardId);

              // 권한 체크
              if (boardIds.indexOf(Number(`${bid}`)) >= 0) {
                enabled = true
                if (urlObject.visible === 'tab') {
                  tab = true
                }
                break
              }
            } catch (e) { /*ignore*/ }

          }
        }

        // 그 외
        else {
          // 대시보드의 경우 lv1, lv2 만 사용할 수 있도록 처리
          if (urlObject.name === '대시보드' && this.getLevel > 2) {
            enabled = false;
          } else {
            enabled = true;
          }
        }
      }

      return { enabled, tab };
    },

    __getBidWithStringBoardId(boardId) {
      try {
        if (boardId.indexOf('/') >= 0) {
          return parseInt(boardId.split('/')[0]);
        } else if (boardId.indexOf('-') >= 0) {
          return parseInt(boardId.split('-')[0]);
        }
      } catch (e) {}
      return boardId;
    },
  }, // methods


  async created() {

    this.$store.commit("menu/CLOSE_PAGE_TRANSLATE");

    await this.$store.dispatch("project/LOAD_PROJECT", { project_id: this.projectId });
    const project = this.$store.state.project.projectInfo;
    if (project && project.menu_json) {
      const menu = JSON.parse(project.menu_json);
      this.$store.commit("menu/SET_MENU", menu);
    }

    await this.$store.dispatch("member/LOAD_MEMBERS_ALL", {
      projectId: this.$route.params.proj_id,
    });

    const color = this.navbarColor === "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor;
    this.updateNavbarColor(color);
    this.setNavMenuVisibility(this.$store.state.mainLayoutType);

    await this.$store.dispatch("member/LOAD_META", {key: 'document_field'});
  },
  async mounted() {
    this.isMobile = window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    this.floatingMenuOpen = localStorage.getItem('FloatingMenu') === 'true' || false;
    await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    await this.loadAlertList();
  },
};
</script>

<style scoped>
.floating-menu-item {
  @apply w-auto flex items-center gap-2 py-4 px-5 rounded-full text-white font-bold text-lg;
  background-color: #758AF5;
}

.floating-menu-item-disabled {
  background-color: #999 !important;
  cursor: not-allowed !important;
  opacity: 0.8;
}

.floating-menu-item-disabled span {
  color: #fff !important;
}

.chat-bubble {
  background: #1E0D6133;
  padding: 10px 14px;
  border-radius: 12px;
  margin-left: auto;
  margin-bottom: 24px;
  max-width: 80%;
  font-size: 14px;
}
.chat-response {
  background: #6670cb22;
  padding: 10px 14px;
  border-radius: 4px;
  margin-right: auto;
  margin-bottom: 24px;
  max-width: 100%;
  white-space: break-spaces;
  font-size: 14px;
}
</style>

<style lang="scss">
[dir] input[readonly="readonly"] {
  background-color: #fafafa;
}

[dir] textarea[readonly="readonly"] {
  background-color: #fafafa;
}

[dir] .file-input .vs-con-input .vs-inputx {
  background-color: #ffffff;
}

[dir] .con-select .vs-select--input {
  background-color: #ffffff;
}

[dir] .vdp-datepicker input[readonly="readonly"] {
  background-color: #ffffff;
}

/* 페이지네이션 중앙 정렬 */
[dir] .vs-con-table .vs-table--pagination .vs-row .vs-col:nth-child(1) {
  display: none !important;
}

[dir] .vs-con-table .vs-table--pagination .vs-row .vs-col:nth-child(2) {
  width: 100% !important;
  justify-content: center !important;
}

/* 페이지네이션 현재페이지 색상 */
[dir] .vs-con-table .vs-table--pagination .vs-pagination-primary .effect,
[dir] .vs-con-table .vs-table--pagination .vs-pagination-primary .vs-pagination--buttons:hover {
  background: rgba(var(--vs-secondary), 1) !important;
}

/* 리스트 스타일 */
.dot {
  width: 10px;
  height: 10px;
  margin-right: 8px;
  border-radius: 10px;
  display: inline-block;
  background-color: #6670cb;
}

.dot.small {
  width: 3px;
  height: 3px;
}

.dot.red {
  background-color: #fb0000;
}

.dot.black {
  background-color: #3c3c3c;
}

.dot.yellow {
  background-color: #ffd600;
}

/* 테이블 스타일 */
ul.table {
  width: 100%;
}

ul.table > li {
  display: grid;
  text-align: center;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #cdcdcd;
  grid-template-rows: minmax(52px, 100%);
}

ul.table > li.tbody {
  background-color: #fff;
}

ul.table > li.tbody > span {
  font-weight: normal !important;
}

ul.table > li > span {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  font-weight: 500;
}

ul.table > li > span:first-child {
  border-left: none;
}

ul.table.table-2 > li {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

ul.table.table-3 > li {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

ul.table.table-4 > li {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

ul.table.table-5 > li {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

ul.table.table-6 > li {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

ul.table.table-7 > li {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

ul.table.table-8 > li {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

ul.table.table-9 > li {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

ul.table.table-10 > li {
  grid-template-columns: 50px repeat(9, minmax(0, 1fr));
}

ul.table.table-no > li {
  grid-template-columns: 60px minmax(0, 100%);
}

ul.table > li.table-2-li {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

ul.table > li.table-3-li {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

ul.table > li.table-4-li {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

ul.table > li.table-5-li {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

ul.table > li.table-6-li {
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

ul.table > li.table-7-li {
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

ul.table > li.table-8-li {
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

ul.table > li.table-9-li {
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

ul.table > li.table-10-li {
  grid-template-columns: 50px repeat(9, minmax(0, 1fr));
}

ul.table > li.table-no-li {
  grid-template-columns: 60px minmax(0, 100%);
}

.vs-row .border {
  text-align: center;
  background-color: #f9f9f9;
}

.bg-fff {
  background-color: #fff;
}

.border-left {
  border-left: 1px solid #cdcdcd !important;
}

.border-right {
  border-right: 1px solid #cdcdcd !important;
}

.border-bottom {
  border-bottom: 1px solid #cdcdcd !important;
}

.border-top {
  border-top: 1px solid #cdcdcd !important;
}

.title {
  font-weight: 500;
}

.router-header {
  padding: 0 16px;

  @media (min-width: theme("screens.xl")) {
    padding: 0;
  }
}
.breadcrumb-note {
  margin-left: 16px;
  font-size: 15px;
  color: #3c3c3c;
  font-weight: 500;
  display: flex;
  align-items: center;

  img {
    margin-right: 4px;
  }
}
.typing {
  display: flex;
  align-items: center;
  gap: 4px;
}

.typing span {
  width: 8px;
  height: 8px;
  background: #999;
  border-radius: 50%;
  animation: blink 1.4s infinite;
}

.typing span:nth-child(1) {
  animation-delay: 0s;
}
.typing span:nth-child(2) {
  animation-delay: 0.2s;
}
.typing span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {
  0%, 80%, 100% { opacity: 0.2; transform: translateY(0); }
  40% { opacity: 1; transform: translateY(-3px); }
}

.ai-chatbot {
  position: fixed;
  bottom: 0;
  right: 14px;
  z-index: 11;
  max-height: 90%;
}
</style>
